<template>
	<div id="printDiv" class="printDiv">
		<div class="row-me center-all title">
			<span style="font-size: 25px;">{{printTitle}}</span>
		</div>
		<div style="margin-top: 20px;">
			<div v-if="printType===0">
				<div class="table-print-border" style="font-size: 16px;">
					<div class="row-me">
						<div class="table-print-header">日期</div>
						<div class="table-print-header">星期</div>
						<div class="table-print-header">当日汇总</div>
						<div class="table-print-header">中药饮片费</div>
						<div class="table-print-header">加工费</div>
						<div class="table-print-header">包材费</div>
						<div class="table-print-header">运费</div>
					</div>
					<div class="row-me" v-for="(item,index) in tableData" :key="index">
						<div class="table-print-cell">{{item.date}}</div>
						<div class="table-print-cell">{{item.week}}</div>
						<div class="table-print-cell">{{item.dayTotal}}</div>
						<div class="table-print-cell">{{item.zyFei}}</div>
						<div class="table-print-cell">{{item.jiaGongFei}}</div>
						<div class="table-print-cell">{{item.baoCaiFei}}</div>
						<div class="table-print-cell">{{item.yunFei}}</div>
					</div>
				</div>
			</div>
			<div v-if="printType===1">
				<div class="table-print-border" style="font-size: 16px;">
					<div class="row-me">
						<div class="table-print-header">处方时间</div>
						<div class="table-print-header">处方订单号</div>
						<div class="table-print-header">医院处方号</div>
						<div class="table-print-header">患者姓名</div>
						<div class="table-print-header">电话号码</div>
						<div class="table-print-header">医院名称</div>
						<div class="table-print-header">配送方式</div>
						<div class="table-print-header">应收汇总</div>
						<div class="column-me row-center" style="flex: 4;">
							<div class="table-print-header width100Per">收款明细</div>
							<div class="row-me width100Per">
								<div class="table-print-header">中药饮片库</div>
								<div class="table-print-header">加工费</div>
								<div class="table-print-header">包材费</div>
								<div class="table-print-header">运费</div>
							</div>
						</div>
					</div>
					<div class="row-me" v-for="(item,index) in tableData" :key="index">
						<div class="table-print-cell">{{item.createTime}}</div>
						<div class="table-print-cell">{{item.orderNo}}</div>
						<div class="table-print-cell">{{item.prescriptionNumber}}</div>
						<div class="table-print-cell">{{item.patientName}}</div>
						<div class="table-print-cell">{{item.patientMobile}}</div>
						<div class="table-print-cell">{{item.hospitalName}}</div>
						<div class="table-print-cell">{{item.deliveryType}}</div>
						<div class="table-print-cell">{{item.totalPrice}}</div>
						<div class="table-print-cell">{{item.zyFee}}</div>
						<div class="table-print-cell">{{item.processFee}}</div>
						<div class="table-print-cell">{{item.packageFee}}</div>
						<div class="table-print-cell">{{item.freightFee}}</div>
					</div>
				</div>
			</div>
			<div v-if="printType===2">
				<div class="table-print-border" style="font-size: 16px;">
					<div class="row-me">
						<div class="table-print-header">传方日期</div>
						<div class="table-print-header">处方订单号</div>
						<div class="table-print-header">医院处方号</div>
						<div class="table-print-header">患者姓名</div>
						<div class="table-print-header">医院名称</div>
						<div class="table-print-header">项目名称</div>
						<div class="table-print-header">单位</div>
						<div class="table-print-header">销售数量</div>
						<div class="table-print-header">成本单价</div>
						<div class="table-print-header">成本总额</div>
						<div class="table-print-header">销售单价</div>
						<div class="table-print-header">销售总额</div>
					</div>
					<div class="row-me" v-for="(item,index) in tableData" :key="index">
						<div class="table-print-cell">{{item.createTime}}</div>
						<div class="table-print-cell">{{item.orderNo}}</div>
						<div class="table-print-cell">{{item.prescriptionNumber}}</div>
						<div class="table-print-cell">{{item.patientName}}</div>
						<div class="table-print-cell">{{item.hospitalName}}</div>
						<div class="table-print-cell">{{item.projectName}}</div>
						<div class="table-print-cell">{{item.unit}}</div>
						<div class="table-print-cell">{{item.saleNums}}</div>
						<div class="table-print-cell">{{item.costUnitPrice}}</div>
						<div class="table-print-cell">{{item.costTotalPrice}}</div>
						<div class="table-print-cell">{{item.saleUnitPrice}}</div>
						<div class="table-print-cell">{{item.saleTotalPrice}}</div>
					</div>
				</div>
			</div>
		</div>
		<button v-show="false" id="btnPrint" v-print="'#printDiv'"></button>
	</div>
</template>

<script>
	import print from 'print-js'
	export default {
		components: {

		},
		props: {
			printTitle: {
				type: String,
				default: '',
			},
			printType: {
				type: Number,
				default: -1,
			},
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {

			}
		},
		// 侦听器
		watch: {

		},
		// 计算属性
		computed: {

		},
		// html加载完成之前
		created() {

		},
		// html加载完成后执行。
		mounted() {

		},
		// 事件方法执行
		methods: {
			startPrint() {
				this.$nextTick(() => {
					document.getElementById("btnPrint").click();
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	/*去除页眉页脚*/
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 3mm;
		/* this affects the margin in the printer settings */
	}

	html {
		background-color: #FFFFFF;
		margin: 0;
		/* this affects the margin on the html before sending to printer */
	}

	body {
		border: solid 1px blue;
		margin: 10mm 15mm 10mm 15mm;
		/* margin you want for the content */
	}

	.printDiv {
		padding: 10px;

		.title {
			margin-top: 20px;
		}
	}
</style>
